import React from "react";

const IconButton = ({
  type,
  disabled=false,
  onClick,
  icon,
  className="",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${className}`}
    >
      {icon}
    </button>
  );
};

export default IconButton;